module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "main-menu__submenu"
  }, [_c('li', {
    staticClass: "main-menu__item has-droprdown has-arrow"
  }, [_c('a', {
    class: {
      'active': _vm.$route.meta.report
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.$root.toggleMenu($event)
      }
    }
  }, [_c('md-icon', {
    staticClass: "arrow-icon-right"
  }, [_vm._v("keyboard_arrow_right")]), _vm._v(" "), _c('md-icon', {
    staticClass: "arrow-icon-down"
  }, [_vm._v("keyboard_arrow_down")]), _vm._v(" "), _c('md-icon', [_vm._v("list")]), _vm._v(" "), _c('span', [_vm._v("Отчеты")])], 1), _vm._v(" "), _c('ul', {
    staticClass: "main-menu__submenu"
  }, [_c('li', {
    staticClass: "main-menu__item"
  }, [_c('router-link', {
    class: ((_vm.$route.name == 'ForwardingReport') ? _vm.$router.options.settingsLinkActiveClass : ''),
    attrs: {
      "to": {
        name: 'ForwardingReport'
      }
    }
  }, [_vm._v("Отчет по экспедированию")]), _vm._v(" "), _c('router-link', {
    class: ((_vm.$route.name == 'NoForwardingReport') ? _vm.$router.options.settingsLinkActiveClass : ''),
    attrs: {
      "to": {
        name: 'NoForwardingReport'
      }
    }
  }, [_vm._v("Отчет по не экспедированным грузам")]), _vm._v(" "), _c('router-link', {
    class: ((_vm.$route.name == 'TransferReport') ? _vm.$router.options.settingsLinkActiveClass : ''),
    attrs: {
      "to": {
        name: 'TransferReport'
      }
    }
  }, [_vm._v("Отчет по перевозкам")]), _vm._v(" "), _c('router-link', {
    class: ((_vm.$route.name == 'RoutelistReport') ? _vm.$router.options.settingsLinkActiveClass : ''),
    attrs: {
      "to": {
        name: 'RoutelistReport'
      }
    }
  }, [_vm._v("Отчет по маршрутным листам")]), _vm._v(" "), _c('router-link', {
    class: ((_vm.$route.name == 'ServicesReport') ? _vm.$router.options.settingsLinkActiveClass : ''),
    attrs: {
      "to": {
        name: 'ServicesReport'
      }
    }
  }, [_vm._v("Отчет по услугам")])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01735ab2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/reports/menus/MainMenu.vue
// module id = 1020
// module chunks = 0